import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobal } from "../../../contexts/GlobalContext";
import { getProfilePicture } from "../../../util/common";

function HeaderCard() {
  const navigate = useNavigate();
  const { user } = useGlobal();
  const [profilePicture, setProfilePicture] = useState("");

  useEffect(() => {
    const loadProfilePicture = async () => {
      if (user?.ProfilePictureMedia) {
        const picture = await getProfilePicture(user.ProfilePictureMedia);
        setProfilePicture(picture);
      }
    };

    loadProfilePicture();
  }, [user?.ProfilePictureMedia]);

  console.log("User Position:", user?.Position);

  const handleEdit = () => {
    navigate("/EditProfile");
  };

  return (
    <>
      <div className="profile-info-left">
        <img src={profilePicture} alt="User" className="profile-photo" />
        <div className="profile-main-details">
          <h2>
            {user?.FirstName} {user?.MiddleName} {user?.LastName}
          </h2>
          <p className="email">{user?.Email}</p>
          <span className="position">Frontend Developer</span>
        </div>
      </div>
      <button className="edit-btn" onClick={handleEdit}>
        <i className="fa-solid fa-pen"></i> Edit Profile
      </button>
    </>
  );
}

export default HeaderCard;
